// material
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
import ErrorDialog from './ErrorDialog';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', error, ...other }, ref) => (
  <Box ref={ref} {...other}>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
    <ErrorDialog open={error ?? false} onClose={() => {}} error={error} />
  </Box>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
